export interface SeoTagsInfo {
    title: string;
    canonicalSlug?: string;
    tags: {
        name?: string;
        property?: string;
        content: string;
    }[];
}

export const mapPageTags: SeoTagsInfo = {
    title: 'Map AI | Location analysis tool',
    tags: [
      {
        name: 'description',
        content:
          'Find where to move and do business with a 1-mile resolution at Map AI location intelligence platform. Access demand forecasting, competitive market analysis, and neighborhood analysis, including detailed demographics by zip code vs. 1 mile, real estate analytics, and more.',
      },
      {
        name: 'keywords',
        content:
          'Map-ai, population density by zip, median income by zip code map, median income map, median household income map, retail store location analysis, location analysis, location intelligence, competitive landscape analysis, map ai',
      },
      {
        property: 'og:title',
        content: 'Map AI | Location analysis tool',
      },
      {
        property: 'og:description',
        content:
          'Find where to move and do business with a 1-mile resolution at Map AI location intelligence platform.',
      },
      {
        property: 'og:url',
        content: 'https://interactive-map-ai.com/',
      },
    ]
};

export const aboutAiChatPageTags: SeoTagsInfo = {
  title: 'About AI Map Chat | How It Works',
  canonicalSlug: '/chat/about',
  tags: [
    {
      name: 'description',
      content:
        'Learn how AI Map Chat works. Discover how to analyze locations, compare demographics, and access real-time data for smarter site selection and business decisions.'
    },
    {
      name: 'keywords',
      content:
        'ai map about, how ai map works, location analysis guide, demographic data tool, site selection tutorial, map ai help, location intelligence platform, demographic analysis, ai location comparison',
    },
    {
      property: 'og:title',
      content: 'About AI Map Chat | Location Intelligence Platform',
    },
    {
      property: 'og:description',
      content:
        'Understand how AI Map Chat extracts and formats real demographic data. Learn to specify areas, compare locations, and make data-driven decisions for site selection.'
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/chat/about',
    },
  ]
}

export const aiPageTags: SeoTagsInfo = {
  title: 'Map AI | Chat with AI Map',
  canonicalSlug: '/chat',
  tags: [
    {
      name: 'description',
      content:
      'Chat with an AI-powered Map. Explore neighborhood demographics, income, and education data. ' +
      'Analyze locations to choose the right place to live or do business.'
    },
    {
      name: 'keywords',
      content:
        'map ai, ai map, location ai, site analysis, location intelligence, demand forecasting software, sales forecast tools, nearest neighborhood analysis, location analysis, demographic data, crime levels',
    },
    {
      property: 'og:title',
      content: 'Map AI | AI demographic data Tool',
    },
    {
      property: 'og:description',
      content:
        'Chat with AI Map. Explore neighborhood demographics, income, education data.' +
        'Decide where to live or do business'
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/chat',
    },
  ]
}
export const reportsPageTags: SeoTagsInfo = {
  title: 'Map AI | Location Analysis Tool & Reporting System',
  canonicalSlug: '/reports/order',
  tags: [
    {
      name: 'description',
      content:
        'Map AI location intelligence platform and reporting system for a detailed neighborhood analysis, business location analysis, demand forecasting, and more.',
    },
    {
      name: 'keywords',
      content:
        'Map ai, map-ai, mapai, ai demand forecasting, retail demand forecasting, revenue forecasting, sales forecasting tools, demand forecasting software, demographics by zip, top neighborhoods',
    },
    {
      property: 'og:title',
      content: 'Map AI | Location Analysis Tool & Reporting System',
    },
    {
      property: 'og:description',
      content:
        'Map AI location intelligence platform and reporting system for a detailed neighborhood analysis.',
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/reports/order',
    },
  ]
}

export const dataSourcesPageTags: SeoTagsInfo = {
  title: 'Map AI | Location intelligence for business & life',
  canonicalSlug: '/info/data-sources',
  tags: [
    {
      name: 'description',
      content:
        'Map AI: the Data You Can Trust. Map AI’s location intelligence tool gathers data from 100+ sources to provide our clients with high-resolution and up-to-date insights for life and business decision-making.',
    },
    {
      name: 'keywords',
      content:
        'Map ai, map-ai, mapai, demand forecast accuracy, location analysis tools, where do I live, where should I live, area median income, location intelligence platform',
    },
    {
      property: 'og:title',
      content: 'Map AI | Location intelligence for business & life',
    },
    {
      property: 'og:description',
      content:
        'Map AI: the Data You Can Trust. Map AI’s location intelligence tool provides high-resolution and up-to-date insights.',
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/info/data-sources',
    },
  ]
}

export const compareLocationsPageTags: SeoTagsInfo = {
  title: 'Map AI | Compare Locations',
  canonicalSlug: '/comparative-location-tool',
  tags: [
    {
      name: 'description',
      content:
        'Compare Locations with Map AI location intelligence platform. Analyze demographics, income, education, and more at a 1-mile resolution. Quick informed decisions for life and business.',
    },
    {
      name: 'keywords',
      content:
        'compare locations tool, compare sites, compare demographics, Map ai, location comparison software, demographic comparison, neighborhood analysis, site selection tool, location intelligence platform',
    },
    {
      property: 'og:title',
      content: 'Map AI | Compare Locations',
    },
    {
      property: 'og:description',
      content:
        'Compare Locations with Map AI location intelligence platform. Analyze demographics, income, education, and more at a 1-mile resolution. Quick informed decisions for life and business.',
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/comparative-location-tool',
    },
  ],
};
export const settingsPageTags: SeoTagsInfo = {
  title: 'Map AI | Location analysis',
  canonicalSlug: '/user/subscription',
  tags: [
    {
      name: 'description',
      content:
        'Accessible location analysis for life and business: 50+ parameters at 1-mile resolution, starting from $4.95.',
    },
    {
      name: 'keywords',
      content:
        'Map ai subscription, map-ai, mapai, best location intelligence software, coffee shop location analysis, grocery demand forecasting, retail store location analysis, laundromat location analysis, median household income by zip code map, map of median income',
    },
    {
      property: 'og:title',
      content: 'Map AI | Location analysis',
    },
    {
      property: 'og:description',
      content:
        'Accessible location analysis for life and business: 50+ parameters at 1-mile resolution.',
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/user/subscription',
    },
  ]
}
